import css from "./Notification.module.css";

const Notification = () => {
  return (
    <>
      <p className={css.text}>Not feedback yet</p>
    </>
  );
};

export default Notification;
